import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { HttpResponse } from '@angular/common/http';
declare var window:any;
@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit ,OnDestroy{
  userId="";
  currentDate:any
  constructor(private route: ActivatedRoute,private authService: AuthService) { }

  ngOnInit() {
    this.userId=this.route.snapshot.params["id"]
    let  currentDate=new Date();
    this.currentDate=currentDate.toDateString();
    this.emailunsubsribe();
  }
  ngOnDestroy(): void {
    window.open('https://web.healthco.app/','_self')
  }
  emailunsubsribe() {
    let request = {
      userId: this.userId,
      isEmailSubscribe:false
    }
    this.authService.unsubsribeEmail(request).subscribe((res: HttpResponse<any>) => {
  
    
    }, err => {
     
    });
  }
}
